import React, { useState, useEffect, useMemo } from 'react'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import './CustomCorrespondenceOptions.scss'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'
import { FilingSourceTypeIds } from '../../../../Utilities/Utilities'

const CustomCorrespondenceOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)

  const [recordTypeOptions, setRecordTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [miscellaneousModuleOptions, setMiscellaneousModuleOptions] = useState([{ label: 'All', value: '0' }])
  const [sourceTypeOptions, setSourceTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [filingTypeOptions, setFilingTypeOptions] = useState([
    { label: 'All', value: '0' },
    { label: 'None', value: 'null' },
  ])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([])
  const [recordSubTypeXref, setRecordSubTypeXref] = useState([])
  const [sourceType, setSourceType] = useState(optionalData.sourceType || 0)
  const [recordType, setRecordType] = useState(optionalData.recordType || 0)
  const [miscellaneousModule, setMiscellaneousModule] = useState(optionalData.miscellaneousModule || 0)
  const [recordSubType, setRecordSubType] = useState(optionalData.recordSubType || 'null')
  const [filingType, setFilingType] = useState(optionalData.filingType || 0)
  const [loading, setLoading] = useState(false)
  const [optionsLoading, setOptionsLoading] = useState(false)

  React.useEffect(() => {
    setLoading(true)      
      if(sourceType === FilingSourceTypeIds.Miscellaneous.toString()){
        api.GET_MISCELLANEOUS_SETTINGS_CUSTOM_CORRESPONDENCE_REASONS(
          sourceType,
          miscellaneousModule,          
          filingType,        
          (res) => {
            dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
            dispatch({
              type: SET_OPTIONAL_DATA,
              optionalData: { sourceType, recordType, recordSubType, filingType, miscellaneousModule },
            })
            setLoading(false)
          },
          (err) => {
            console.error('retrieving', err)
            setLoading(false)
          }
        )
      }
      else {      
        api.GET_SETTINGS_CUSTOM_CORRESPONDENCE_REASONS(
          sourceType,
          recordType,
          recordSubType,
          filingType,        
          (res) => {
            dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
            dispatch({
              type: SET_OPTIONAL_DATA,
              optionalData: { sourceType, recordType, recordSubType, filingType, miscellaneousModule },
            })
            setLoading(false)
          },
          (err) => {
            console.error('retrieving', err)
            setLoading(false)
          }
        )
      }        
  }, [sourceType, recordType, recordSubType, filingType, miscellaneousModule])

  const selectSourceType = (val) => {
    setSourceType(val)
    if (val === '0') {
      setRecordTypeOptions([{ label: 'All', value: '0' }])
      setMiscellaneousModuleOptions([{ label: 'All', value: '0' }])
      setRecordSubTypeOptions([
        { label: 'All', value: '0' },
        { label: 'None', value: 'null' },
      ])
      setFilingTypeOptions([{ label: 'All', value: '0' }])
      setRecordType(0)
      setMiscellaneousModule(0)
      setRecordSubType('null')
      setFilingType(0)
      getSourceTypeOptions()
    } else {
      const option = sourceTypeOptions.find((option) => option.value === Number(val))
      if (option.moduleName === 'Business') setRecordSubType('0')
      getLookupTypeDropdownOptions(option.moduleName)
    }
  }

  const getSourceTypeOptions = (firstRender = false) => {
    api.GET_SOURCE_TYPE_OPTIONS(
      (res) => {
        setSourceTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name === 'Receipt' ? 'Payment' : t.Name,
            moduleName: t.ModuleName,
          })),
        ])
        if (firstRender) {
          getLookupTypeDropdownOptions(
            res.find((option) => option.Id === Number(sourceType)).ModuleName
          )
        }
      },
      (err) => console.error(err.message)
    )
  }

  const getLookupTypeDropdownOptions = (moduleName) => {
    if (moduleName !== 'All' && moduleName !== 'Miscellaneous') {
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
        moduleName,
        'FilingType',
        (res) =>
          setFilingTypeOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
          ]),
        (err) => {
          setRecordTypeOptions([{ label: 'All', value: '0' }])
          setFilingTypeOptions([{ label: 'All', value: '0' }])
          console.error(err.message)
        }
      )
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
        moduleName,
        'RecordType',
        (res) =>
          setRecordTypeOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
          ]),
        (err) => {
          setRecordTypeOptions([{ label: 'All', value: '0' }])
          setFilingTypeOptions([{ label: 'All', value: '0' }])
          console.error(err.message)
        }
      )
    }
    else if(moduleName !== 'All'){
      api.GET_MISCELLANEOUS_MODULES(        
        (res) =>
        {
          res.sort((a,b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
          setMiscellaneousModuleOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
          ])
          selectMiscellaneousModule(miscellaneousModule)
          setRecordType(0)
          setRecordSubType('null')
        },
        (err) => {
          setMiscellaneousModuleOptions([{ label: 'All', value: '0' }])
          setFilingTypeOptions([{ label: 'All', value: '0' }])
          console.error(err.message)
        }
      )
    }
  }

  const selectMiscellaneousModule = (val) => {
    setMiscellaneousModule(val)
    setFilingType(0)
    if(val !== '0'){
      api.GET_MISCELLANEOUS_MODULE_FILING_TYPES(
        val,
        (res) => {
          setFilingTypeOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name
            })),
          ])          
        },
        (err) => console.error(err.message)
      )
    }
    else{
      setFilingTypeOptions([{ label: 'All', value: '0' }])
    }
  }

  useEffect(() => {
    if (sourceTypeOption && sourceTypeOption.moduleName === 'Business') {
      setOptionsLoading(true)
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
        sourceTypeOption.moduleName,
        'RecordSubType',
        (res) => {
          setRecordSubTypeOptions([
            { value: '0', label: 'All' },
            { value: 'null', label: 'None' },
            ...res.map((t) => {
              return {
                value: t.Id,
                label: t.Name,
              }
            }),
          ])
          if (sourceTypeOption.moduleName === 'Business') {
            api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
              recordType,
              (res) => {
                setRecordSubTypeXref(res.BusinessRecordSubTypeIds)
                setOptionsLoading(false)
              },
              (err) => {
                console.error('retrieving', err)
                setRecordSubTypeXref([])
                setOptionsLoading(false)
              }
            )
          } else {
            setOptionsLoading(false)
          }
        },
        (err) => {
          console.warn('Module does not support RecordSubType')
          setOptionsLoading(false)
        }
      )
    }
    setRecordSubTypeOptions([
      { label: 'All', value: '0' },
      { label: 'None', value: 'null' },
    ])
  }, [sourceType, sourceTypeOptions, sourceTypeOption, recordType])

  useEffect(() => {
    getSourceTypeOptions(true)
  }, [])

  const sourceTypeOption = useMemo(() => {
    return sourceTypeOptions.find((type) => type.value === Number(sourceType))
  }, [sourceTypeOptions, sourceType])

  useEffect(() => {
    if (sourceTypeOption && sourceTypeOption.moduleName === 'Business') setRecordSubType('0')
    else setRecordSubType('null')
  }, [sourceTypeOption])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Source Type"
        noPlaceholder
        value={sourceType}
        onChange={(val) => {
          selectSourceType(val)
        }}
        options={sourceTypeOptions}
      />
      {sourceType !== FilingSourceTypeIds.Miscellaneous.toString() ? <SelectBox
        label="Record Type"
        noPlaceholder
        value={recordType}
        onChange={(val) => {
          setRecordType(val)
        }}
        options={recordTypeOptions}
      /> : null}
      {sourceType === FilingSourceTypeIds.Miscellaneous.toString() ? <SelectBox
        label="Miscellaneous Module"
        noPlaceholder
        value={miscellaneousModule}
        onChange={(val) => {
          selectMiscellaneousModule(val)
        }}
        options={miscellaneousModuleOptions}
      /> : null}
      {sourceTypeOption && sourceTypeOption.moduleName === 'Business' ? (
        <SelectBox
          label="Record Sub Type"
          noPlaceholder
          value={recordSubType}
          onChange={(val) => {
            setRecordSubType(val)
          }}
          options={recordSubTypeOptions.filter(
            (opt) =>
              opt.value === 'null' ||
              opt.value === '0' ||
              recordType.toString() === '0' ||
              recordSubTypeXref.includes(opt.value)
          )}
        />
      ) : null}
      <SelectBox
        label="Filing Type"
        noPlaceholder
        value={filingType}
        onChange={(val) => {
          setFilingType(val)
        }}
        options={filingTypeOptions}
      />
      {(loading || optionsLoading) && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default CustomCorrespondenceOptions
